var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5371 0C17.9084 0.0992578 18.3325 0.0870117 18.7198 0.13793C26.0005 1.1015 31.9102 6.99381 32.8622 14.2854C32.9124 14.6728 32.9015 15.0969 33.0001 15.4688V17.5312C32.9008 17.9025 32.9131 18.3272 32.8622 18.7146C31.8986 25.9978 26.0089 31.9101 18.7198 32.8621C18.3325 32.9123 17.9084 32.9014 17.5371 33H15.4753C15.104 32.9007 14.6799 32.913 14.2926 32.8621C7.01258 31.8979 1.10223 26.0062 0.150903 18.7146C0.10063 18.3272 0.111587 17.9031 0.0129737 17.5312C0.0426221 16.8493 -0.0269873 16.1487 0.0129737 15.4688C0.491216 7.28643 7.29618 0.478887 15.4753 0H17.5371ZM25.3192 9.23484C24.859 9.2935 24.587 9.48428 24.237 9.764L13.1885 20.0423L8.48663 15.0163C6.50598 13.2793 3.78606 15.4874 5.07512 17.7845L12.9958 26.2956C13.9297 25.4061 14.8507 24.4967 15.7975 23.6208C19.318 20.3659 22.9286 17.1697 26.3653 13.8258C26.9976 13.211 27.8232 12.5658 27.9102 11.6331C28.0552 10.0785 26.8274 9.04342 25.3198 9.23484H25.3192Z",
    fill: "#29C013"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e06397dfdcb00a1680bf5f417fe425b6.svg";
export { ForwardRef as ReactComponent };